import { Navigate } from 'react-router-dom';

import { ACTIONS } from '../../../constants/constants';
import { useAbility } from '../AbilityProvider';
import { Subjects } from '../defineAbility';

export function CanRoute({
  action,
  subject,
  element,
}: {
  action: ACTIONS;
  subject: Subjects;
  element: JSX.Element;
}): JSX.Element {
  const ability = useAbility();
  return ability.can(action, subject) ? element : <Navigate to="/" replace />;
}
